module.exports = __webpack_public_path__ + "static/wiczlino1-de518b7886eacbd61b181fb2fd9f68ec.jpg";